export const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const tableWrapperStyle = {
  padding: 0,
};

export const dividerStyle = {
  borderStyle: 'initial',
  borderColor: ({ palette }) => palette.border.default,
  margin: '48px 0',
};

export const typographyStyles = {
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '16px',
  fontWeight: 700,
  color: ({ palette }) => palette.text.secondary,
};

export const previousAddressContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  paddingTop: '24px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const previousAddressFormControlsStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};

export const addAnotherAddressStyles = {
  marginTop: '24px',
};

export const emptyMessageCellStyles = {
  padding: 0,
  '& .table-cell__content_box': {
    padding: '8px !important',
    height: 'unset !important',
  },
};
